let baseUrl = '';
if (process.env.NODE_ENV === 'production') {
   baseUrl = 'https://gastrovita.inkless.digital/';
} else {
   baseUrl = 'http://dev.denarius/';
}
export default baseUrl;



// WEBPACK FOOTER //
// ./src/config.js